import React, { PureComponent } from 'react'
import { getObjValue, addSuffix } from '@hlj/hlj-utils'
import styles from './style.module.less'
import SlideModal from '@common/SlideModal'
import { toJS } from 'mobx'

export default class extends PureComponent {
  state = {
    prew: false,
    initialSlide: 0
  }
  static defaultProps = {
    imgs: [],
    imgW: 120,
    imgH: 120,
    keyField: 'url',
    autoSuffix: true,
    defaultSrc: 'http://qnm.hunliji.com/o_1an6lmevq1fg3lqt18n6188hvh17.jpg',
    target: '_self', //_blank
    title: null //每个iteem的标题或者描述信息
  }
  itemClick = (item, i, imgs) => () => {
    const { onPreview, keyField, target } = this.props
    if (onPreview) {
      onPreview(item, i, imgs)
    } else {
      target === '_blank'
        ? window.open(getObjValue(item, keyField))
        : this.setState({ prew: true, initialSlide: i })
    }
  }
  closePrew = () => {
    this.setState({ prew: false, initialSlide: 0 })
  }

  render() {
    const { prew, initialSlide } = this.state
    const {
      imgs,
      imgW,
      imgH,
      suffix,
      preSuffix,
      keyField,
      defaultSrc,
      style,
      title,
      preWidth,
      preHeight,
      autoSuffix
    } = this.props
    const _suffix = suffix || `imageView2/2/w/${imgW}/h/${imgH}`
    let imgList = Array.isArray(toJS(imgs)) ? imgs : [imgs]
    return imgs && imgs.length ? (
      <ul className={styles.container} style={style}>
        {imgList.map((item, i) => {
          const src = getObjValue(item, keyField) || defaultSrc
          const _title = typeof title === 'function' ? title(item, i) : title
          const style = {
            height: imgH,
            width: imgW,
            backgroundImage: `url(${
              autoSuffix ? addSuffix(src, _suffix, true) : src
            })`,
            backgroundSize: '100%'
          }
          return (
            <li
              key={i}
              className={styles.item}
              style={style}
              onClick={this.itemClick(item, i, imgs)}
            >
              {_title}
            </li>
          )
        })}
        {prew && (
          <SlideModal
            autoSuffix={autoSuffix}
            suffix={preSuffix}
            slideWidth={preWidth}
            slideHeight={preHeight}
            visible={prew}
            keyField={keyField}
            imgList={imgs}
            initialSlide={initialSlide}
            onCancel={this.closePrew}
          />
        )}
      </ul>
    ) : null
  }
}
